<main class="premiit">
  <app-header></app-header>
  <div class="premiit_body" [@routeAnimations]="prepareRoute(outlet)">
    <div *ngIf="loading" class="premiit_blackout"></div>
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</main>